import Vue              from "vue"
import VueRouter        from "vue-router"
import Refinement       from "../components/configurator/Refinement"
import Customization    from "../components/configurator/Customization"

Vue.use(VueRouter)

const routes = [
    {path: '/', name: 'refinement', component: Refinement, meta: {step: 2}},
    {path: '/personalisierung', name: 'customizationType', component: Customization, meta: {step: 3}},
]

const router = new VueRouter({routes})

export default router
